const isObject = item =>
  !!item && typeof item === 'object' && item !== null && !Array.isArray(item);

module.exports = isObject;
